import routerOptions0 from "/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/root/workspace/__flow_work/__flow_builds/d4099d0b-ea7f-40f7-9d4a-69741bb03d6e/workspace/soho-store-web_yhIy/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}